// extracted by mini-css-extract-plugin
export var linkText = "_od-0";